var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.115942 11.8772C-0.0386473 11.7118 -0.0386473 11.4431 0.115942 11.2777L5.05314 6.0058L0.115942 0.72359C-0.0386473 0.558198 -0.0386473 0.289436 0.115942 0.124044C0.270531 -0.041348 0.521739 -0.041348 0.676329 0.124044L5.88406 5.69569C5.96135 5.77839 6 5.88176 6 5.99546C6 6.09883 5.96135 6.21254 5.88406 6.29524L0.676329 11.8669C0.521739 12.0426 0.270531 12.0426 0.115942 11.8772V11.8772Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveArrowIcon);
export default __webpack_public_path__ + "static/media/ActiveArrowIcon.92b78515e5259613b0b67ab85344342e.svg";
export { ForwardRef as ReactComponent };